import axiosInstance from '../axiosConfig';
import { ConsentMeta } from '../../types/consent';

class ConsentService {
  async listConsentTypes(): Promise<ConsentMeta[]> {
    const res = await axiosInstance.get<{ data: ConsentMeta[] }>('/consents/types');
    return res.data.data ?? [];
  }
}

const consentService = new ConsentService();
export default consentService;
